import React from 'react';
import PropTypes from 'prop-types';
import {dispatch, connect} from 'utils/state_manager';

import {Box, Stack} from 'views/components';
import {useNavigate} from 'views/module';

import ClientTile from './sections/ClientTile';
import CaregiverTile from './sections/CaregiverTile';
import EventHeader from './sections/EventHeader';
import TimeTile from './sections/TimeTile';
import NotesTile from './sections/NotesTile';
import EventTimelineTile from './sections/EventTimelineTile';
import LoadingScreen from './skeleton/LoadingScreen';
import Popup from './sections/Popup';

import backend from 'utils/backend';

const EventDetail = (props) => {
  const {eventRn, statusProgressWrap: progressWrap} = props;

  const [event, setEvent] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [model, setModel] = React.useState(null);

  const navigate = useNavigate();

  const handleCancelEvent = async (clientRn, eventRn, reasonForException, onSuccess=() => undefined) => {
    progressWrap(async () => {
      await backend.event.cancelEvent(clientRn, eventRn, reasonForException);
      navigate(-1);
      onSuccess();
    });
  };

  const handleRescheduleEvent = async (clientRn, eventRn, reasonForException, eventData, onSuccess=() => undefined) => {
    progressWrap(async () => {
      const output = await backend.event.rescheduleEvent(clientRn, eventRn, reasonForException, eventData);

      navigate(`/schedule/event/${output.eventRn}`, {});

      onSuccess();
    });
  };

  const handleDeclineRequest = async (eventRn, type, declineReason, onSuccess=() => undefined) => {
    progressWrap(async () => {
      const adminAction = {
        status: 'DECLINED',
        reason: declineReason,
      };

      const {eventUpdateData} = await backend.event.declineEvent(eventRn, type, adminAction);

      setEvent((e) => {
        const caregiverUpdates = e.caregiverUpdates;

        const caregiverUpdateIndex = caregiverUpdates.findIndex((e) => e.type === type);

        caregiverUpdates[caregiverUpdateIndex] = eventUpdateData;

        return {
          ...e,
          caregiverUpdates: [...caregiverUpdates],
        };
      });


      onSuccess();
    });
  };

  const handleUpdateEventInfo = async (clientRn, eventRn, info, onSuccess=() => undefined) => {
    progressWrap(async () => {
      await backend.event.updateEventInfo(clientRn, eventRn, info);

      setEvent((e) => {
        return {
          ...e,
          info,
        };
      });

      onSuccess();
    });
  };

  const handleUpdateAllEventInfo = async (clientRn, recurrenceRn, info, onSuccess=() => undefined) => {
    progressWrap(async () => {
      await backend.event.updateAllEventInfo(clientRn, recurrenceRn, info);

      setEvent((e) => {
        return {
          ...e,
          info,
        };
      });

      onSuccess();
    });
  };

  const handleUpdateEventCaregiver = async (clientRn, eventRn, caregiverData, reasonForException, onSuccess=() => undefined) => {
    progressWrap(async () => {
      const output = await backend.event.updateEventCaregiver(clientRn, eventRn, caregiverData, reasonForException);

      navigate(`/schedule/event/${output.eventRn}`, {});

      onSuccess();
    });
  };

  React.useEffect(() => {
    progressWrap(async () => {
      setLoading(true);
      const result = await backend.event.loadEvent(eventRn, true, true, true, true); ;
      setEvent(result.event);
      setLoading(false);
    }, {showProgress: false});
  }, [eventRn]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Box sx={{p: 3, margin: 'auto'}}>
      <Popup
        model={model}
        setModel={setModel}
        event={event}
        handleUpdateEventCaregiver={handleUpdateEventCaregiver}
        handleCancelEvent={handleCancelEvent}
        handleRescheduleEvent={handleRescheduleEvent}
        handleDeclineRequest={handleDeclineRequest}
      />
      <EventHeader
        event={event}
        setModel={setModel}
      />
      <Stack
        direction={{xs: 'column', sm: 'row'}}
        spacing={2}
        mb={2}
      >
        <Box sx={{width: '100%'}}>
          <ClientTile client={event.clientData} />
        </Box>
        <Box sx={{width: '100%'}}>
          <CaregiverTile
            caregiver={event.caregiverData}
            setModel={setModel}
          />
        </Box>
      </Stack>
      <TimeTile event={event} />
      <NotesTile event={event}
        onUpdateEventInfo={handleUpdateEventInfo}
        onUpdateAllEventInfo={handleUpdateAllEventInfo}
      />
      <EventTimelineTile
        event={event}
        setModel={setModel}
        handleRescheduleEvent={handleRescheduleEvent}
        handleCancelEvent={handleCancelEvent}
      />
    </Box>
  );
};

EventDetail.propTypes = {
  eventRn: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(EventDetail));
